/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { RedirectFromQueryParams } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class LinkRedirectController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags link-redirect-controller
   * @name PathRedirect
   * @request GET:/api/deeplink/{path}/**
   */
  pathRedirect = (path: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/deeplink/${path}/**`,
      method: 'GET',
      ...params,
    })

  static pathRedirectPath = '/deeplink/${path}/**'
  static pathRedirectMethod = 'GET'
  /**
   * No description
   *
   * @tags link-redirect-controller
   * @name RedirectFromQuery
   * @request GET:/api/deeplink/
   */
  redirectFromQuery = (query: RedirectFromQueryParams, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/deeplink/`,
      method: 'GET',
      query: query,
      ...params,
    })

  static redirectFromQueryPath = '/deeplink/'
  static redirectFromQueryMethod = 'GET'
  /**
   * No description
   *
   * @tags link-redirect-controller
   * @name WellKnownAssetLinks
   * @request GET:/api/deeplink/.well-known/assetlinks.json
   */
  wellKnownAssetLinks = (params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/deeplink/.well-known/assetlinks.json`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static wellKnownAssetLinksPath = '/deeplink/.well-known/assetlinks.json'
  static wellKnownAssetLinksMethod = 'GET'
  /**
   * No description
   *
   * @tags link-redirect-controller
   * @name WellKnownAppleAppSiteAssociation
   * @request GET:/api/deeplink/.well-known/apple-app-site-association
   */
  wellKnownAppleAppSiteAssociation = (params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/deeplink/.well-known/apple-app-site-association`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static wellKnownAppleAppSiteAssociationPath = '/deeplink/.well-known/apple-app-site-association'
  static wellKnownAppleAppSiteAssociationMethod = 'GET'
}
